import $ from 'jquery';
$(document).ready(function () {
// phpcs:ignore WordPressVIPMinimum.JS.Window.location 
  const url = window.location.href;
  try {
    const safeUrl = new URL(url);
    if (safeUrl.href.includes('tmap')) {
     $('.wp-block-heading').addClass('tmap-heading');
    }
  } catch (e) {
    console.error('Invalid URL:', e);
  }
});